module.exports = __webpack_public_path__ + "static/media/075.61cd3c58.jpg";